module.exports = __webpack_public_path__ + "static/media/fiche_IPID.c4e87cb6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/documents/common/fiche_IPID.pdf
// module id = 849
// module chunks = 40